/* ===========================================================================
   Item
   =========================================================================== */

import {cartRemoveItem} from './cart';
import {initAccordion} from './accordion';
import {openClass} from "../settings/settings";
import {closePopin, closeDeliveryPopin} from "./popin";

/* ===========================================================================
   Moving Elements
   =========================================================================== */

/**
 * [movingItemSummaryList description]
 * @return {[type]} [description]
 */
export function movingItemSummaryList() {

  const $itemSummaryBody = $('#js-item-summary-body');
  const $itemSummaryList = $('#js-item-summary-list');

  if (Foundation.MediaQuery.atLeast('large')) {
    $itemSummaryList.appendTo($itemSummaryBody);
  } else {
    $itemSummaryList.insertAfter($itemSummaryBody);
  }
}

/**
 * [movingItemSummaryList description]
 * @return {[type]} [description]
 */
export function movingItemName() {

  const $itemName = $('#js-item-name');
  const $itemNameContainer = $('#js-item-name-container');
  const $itemDescription = $('#js-item-description');
  const $saleConfirm = $('#item-sale-confirm');

  if (!$saleConfirm) {
    if (Foundation.MediaQuery.atLeast('large')) {
      $itemDescription.prepend($itemName);
    } else {
      $itemNameContainer.prepend($itemName);
    }
  }
}

/**
 * [movingItemPayment description]
 * @return {[type]} [description]
 */
export function movingItemPayment() {

  const $payment = $('#js-payment-moving');
  const $parent = $('#js-payment');
  const $purchasingProcess = $('#js-purchasing-process');

  if (Foundation.MediaQuery.atLeast('large')) {
    $purchasingProcess.append($payment);
    $parent.addClass('is-hidden');
  }

}

/**
 * [movingItemSeeAllPairs description]
 * @return {[type]} [description]
 */
export function movingItemSeeAllPairs() {
  const seeAllPairs = $('#js-all-pairs');
  const $originalLocation = $('.item-list-wrapper .item-list-header');
  const $mobileLocation = $('.item-list-wrapper .row.column');

  if (Foundation.MediaQuery.atLeast('large')) {
    seeAllPairs.appendTo($originalLocation);
  } else {
    seeAllPairs.appendTo($mobileLocation);
  }
}

/**
 * [movingManufacturedItemSizeSelector description]
 * @return {[type]} [description]
 */
export function movingManufacturedItemSizeSelector() {
  const selector = $('#js-manufactured-itemSize-Selector');
  const $originalLocation = $('#js-add-to-cart');
  const $mobileLocation = $originalLocation;

  if (Foundation.MediaQuery.atLeast('large')) {
    selector.prependTo($originalLocation);
  } else {
    selector.prependTo($mobileLocation);
  }
}

export function searchPointRelais() {
  $(document).on('click','#search_point_relais',function() {
    const $popin = $(this).parents('.popin-wrapper');
    const $inputContainer = $(this).siblings('.input-field-container');
    const address = $popin.find('#search_point_relais_address').val();
    if (address !== "") {
      $inputContainer.children('input').removeClass('is-invalid-input');
      $inputContainer.children('.form-error').removeClass('is-visible');
      $popin.find('.popin-content').addClass('is-loading');
      fetch(`/search/${address}`, {method: 'PUT'})
        .catch(alert)
        .then(response => response.text())
        .then(data => {
          $popin.find('#point_relais_list').replaceWith(data);
          initAccordion();
          addSelectPointRelaisEvent();
          $popin.find('.popin-content').removeClass('is-loading');
        });
    } else {
      $inputContainer.children('input').addClass('is-invalid-input');
      $inputContainer.children('.form-error').addClass('is-visible');
    }
  });
}

export function addSelectPointRelaisEvent() {
  $('a.point-relais').on('click', function (event) {
    const deliveryId = $(event.target).siblings("input[type='hidden']").val();
    const itemId = $(event.target).parents('.js-cart-item-popin-wrapper').attr('data-item-id');

    fetch(`delivery_place/${itemId}/point_relais/${deliveryId}`, {method: 'PUT'})
      .catch(alert)
      .then(response => response.json())
      .then(data => {updateCartPriceInfo(data);updateCartDeliveryPlaceInfo(data, deliveryId, itemId); closeDeliveryPopin();});
  });
}

export function updateCartPriceInfo($infos) {
  validateCart($infos);
  $('.cart-footer .fees  li.total-items > span.amount').text($infos.price);
  $('.cart-footer .fees  li.total-shipping > span.amount').text($infos.deliveryFees);
  $('.cart-footer .fees  li.total-fees > span.amount').text($infos.fees);
  $('.cart-footer .total p.total-info > span.amount').text($infos.totalPrice);
}

export function updateCartDeliveryPlaceInfo($infos, deliveryId, itemId) {
  validateCart($infos);

  $('#selected-delivery-place-' + itemId).remove();

  if (deliveryId) {
    //let deliveryIdSelected = $infos.shops[`${deliveryId}`].id,
    let shopName = $infos.shops[`${deliveryId}`].name,
      shopAddress = $infos.shops[`${deliveryId}`].postalCode + ' '+$infos.shops[`${deliveryId}`].city,
      itemIdSelected = $infos.shops[`${deliveryId}`].items[`${itemId}`].id;

    $('.choice-wrapper[data-item-id=' + itemIdSelected + ']').find('.delivery-link').html('Modifier');
    $('.choice-wrapper[data-item-id=' + itemIdSelected + ']')
      .prepend('<div id="selected-delivery-place-' + itemIdSelected + '" class="selected-delivery-place">' +
        '<span id="selected-delivery-place-name-' + itemIdSelected + '">' + shopName + '</span> - ' +
        '<span id="selected-delivery-place-address-' + itemIdSelected + '">' + shopAddress + '</span>' +
        '</div>');
  }
}

export function validateCart($infos) {
  if ($infos.valid) {
    $('.panier-checkout-error').text('').addClass('is-hidden');
    $('#panier-button-checkout').removeClass('disabled');
  } else {
    $('#panier-button-checkout').addClass('disabled');
  }
}
$( document ).ready(function() {
  $(".delivery-method-select").each(function() {
    const deliveryPrice = $(this).parent().find('.delivery-price');

    if ($(this).find(":selected").attr('data-price')) {
      deliveryPrice.html($(this).find(":selected").attr('data-price')/100 + ' €');
    } else {
      deliveryPrice.html('Gratuit');
    }
  });
});

export function movingItemSelectDeliveryPoint() {

  $('.delivery-method-select').on('change', function (event) {
    const deliveryMethodId = $(event.target).val();
    const itemId = $(event.target).parent().attr('data-item-id');
    const deliveryPrice = $(this).parent().find('.delivery-price');
    const deliveryMethod = $(this).find(":selected").attr('data-type');
    if ($(this).find(":selected").attr('data-price')) {
      deliveryPrice.html($(this).find(":selected").attr('data-price')/100 + ' €');
    } else {
      deliveryPrice.html('Gratuit');
    }

    if (deliveryMethod === 'shop_2_shop') {
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').addClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal').removeClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery').removeClass('is-inline-block');

      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.select-shop-button').addClass('is-hidden');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').removeClass('is-hidden');

      if ($(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.selected-delivery-place').is(':empty')) {
        $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop .delivery-link').html('Modifier');
      } else {
        $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop .delivery-link').html('Choisir un point relais');
      }

    } else if (deliveryMethod === 'shop_withdrawal'){
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal').addClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').removeClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery').removeClass('is-inline-block');

      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal').removeClass('is-hidden');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').addClass('is-hidden');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery').addClass('is-hidden');

      if ($(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.selected-delivery-place').is(':empty')) {
        $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal .delivery-link').html('Modifier');
      } else {
        $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal .delivery-link').html('Choisir une boutique');
      }
    }  else if (deliveryMethod === 'shop_delivery'){
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery').addClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').removeClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal').removeClass('is-inline-block');

      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery').removeClass('is-hidden');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').addClass('is-hidden');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal').addClass('is-hidden');

      if ($(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.selected-delivery-place').is(':empty')) {
        $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery .delivery-link').html('Modifier');
      } else {
        $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery .delivery-link').html('Choisir une boutique');
      }
    } else {
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').removeClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal').removeClass('is-inline-block');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery').removeClass('is-inline-block');

      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_withdrawal').addClass('is-hidden');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_2_shop').addClass('is-hidden');
      $(this).closest('.selects-wrapper').nextAll('.choice-wrapper').find('.shop_delivery').addClass('is-hidden');

    }

    fetch(`delivery_method/${itemId}/delivery/${deliveryMethodId}`,
      {method: 'PUT'})
      .catch(alert)
      .then(response => response.json())
      .then(data => { updateCartPriceInfo(data); updateCartDeliveryPlaceInfo(data, null, itemId);});
  });

  addSelectPointRelaisEvent();

  $('.select-shop-button').on('click', function(event) {
    $('#select-delivery-place').attr('data-item-id',$(event.target).parent().attr('data-item-id'));
  });

  $('.shop-delivery.button').on('click', function (event) {
    const deliveryId = $(event.target).attr('data-value');
    const itemId = $('#select-delivery-place').attr('data-item-id');

    fetch(`delivery_place/${itemId}/shop/${deliveryId}`, {method: 'PUT'})
      .catch(alert)
      .then(response => response.json())
      .then(data => {updateCartDeliveryPlaceInfo(data, deliveryId, itemId); closePopin();});
  });

  let deliveryMethods = $('.delivery-method-select');
  deliveryMethods.each(function() {
    if ($(this).find('option:selected').length === 0 || $(this).parents('.selects-wrapper').first().next('.choice-wrapper').find('[id^=selected-delivery-place-]').length === 0) {
      $('#panier-button-checkout').addClass('disabled');
      return false;
    } else {
      $('#panier-button-checkout').removeClass('disabled');
      $('.panier-checkout-error').text('').addClass('is-hidden');
    }
  });

  $('#panier-button-checkout').on('click', event => {
    if ($('#panier-button-checkout').hasClass('disabled')) {
      event.preventDefault();
      $('.panier-checkout-error')
          .text('La méthode de livraison ou un lieu d’expédition n’a pas été sélectionné pour au moins un produit de votre panier.')
          .removeClass('is-hidden');
    }
  });
}
